<template>
  <div class="documents-page-wrapper">
    <static-pages-header @mobileMenuToggle="mobileMenuToggle"/>
    <div class="documents-container" :class="{'heading-container-mobile-menu-open': isMobileMenuOpen}">
      <div class="documents-title">{{ $t('message.documentsPage.title') }}</div>
      <a :href="require('../../../public/static/rules.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.rules') }}</div>
      </a>

      <a :href="require('../../../public/static/newRules.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.newRules') }}</div>
      </a>

      <a :href="require('../../../public/static/serviceContract.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.serviceContract') }}</div>
      </a>

      <a :href="require('../../../public/static/newServiceContract.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.newServiceContract') }}</div>
      </a>

      <a :href="require('../../../public/static/contractTemplate.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.contractTemplate') }}</div>
      </a>

      <a :href="require('../../../public/static/newContractTemplate.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.newContractTemplate') }}</div>
      </a>

      <a :href="require('../../../public/static/scoring.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.scoring') }}</div>
      </a>

      <a :href="require('../../../public/static/personalDataProcessing.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.personalDataProcessing') }}</div>
      </a>

      <a :href="require('../../../public/static/paritetOffer.pdf')" target="_blank" class="info-container-item-document-block mb20">
        <img src="../../../public/custom/images/document-img.svg" alt="Document image">
        <div>{{ $t('message.documentsPage.documents.offer') }}</div>
      </a>
    </div>
  </div>
</template>

<script>
import StaticPagesHeader from '../../components/common/StaticPagesHeader.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'Documents',
  components: {
    StaticPagesHeader
  },
  data() {
    return {
      isMobileMenuOpen: false,
    }
  },
  methods: {
    mobileMenuToggle(value) {
      this.isMobileMenuOpen = value;
    },
    signUp() {
      this.$router.push({ name: 'msi' });
    },
  },
  computed: {
    ...mapGetters(['profile']),
    isAuthorized() {
      return this.profile?.role;
    },
  }
}
</script>

<style lang="scss" scoped>
.documents-page-wrapper {
  @include base-page-wrapper;
  @include static-heading-container;
}

.documents-container {
    @include base-page-container;

    padding: 70px 50px 140px 50px;
    box-sizing: border-box;
    justify-content: flex-start;
    flex-direction: column;
  }
.documents-title {
  margin-bottom: 40px;
  font-weight: 700;
  font-size: 40px;
  line-height: 125%;
  color: #181A1B;  
}

.info-container-item-document-block {
    margin-top: 10px;
    display: flex;
    align-items: center;
    text-decoration: none;

    img {
      height: 34px;
      width: 34px;
      margin-right: 5px;
    }

    div {
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
      color: #41BF7B;
      text-decoration: none;
    }
  }

  @media screen and (max-width: 940px) {
    .documents-container {
      padding: 50px 0 140px 0;
    }

    .documents-title {
      font-size: 30px;
    }
  }
</style>